<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="7">
        <el-dialog title="Confirm Email Delete" :visible.sync="emailDeleteForm" width="30%">
          <span>Remove email [{{removeEmail}}]?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="emailDeleteForm = false">Cancel</el-button>
            <el-button type="primary" @click="confirmDeleteEmail(removeEmail)">Delete</el-button>
          </span>
        </el-dialog>

        <el-dialog title="Add New Email Address" :visible.sync="emailAddForm" width="30%">
          <span>
            <el-form
              :model="newEmailForm"
              :rules="newEmailRules"
              ref="settingsForm"
              label-width="120px"
            >
              <el-form-item label="Email Address:">
                <el-input v-model="newEmailForm.email"></el-input>
              </el-form-item>
            </el-form>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="emailAddForm = false">Cancel</el-button>
            <el-button type="primary" @click="confirmAddEmail()">Add Email</el-button>
          </span>
        </el-dialog>
        <b-card :header="'Settings for ' + getPackageNameById(packageId)">
          <el-form
            :model="packageSettings"
            :rules="rules"
            ref="settingsForm"
            label-width="160px"
            class="demo-settingsForm"
          >
            <el-form-item label="Package Name:" prop="name">
              <el-input v-model="packageSettings.name"></el-input>
            </el-form-item>
            <el-form-item label="Report Language:" prop="defaultReport">
              <el-select v-model="packageSettings.defaultReport" placeholder="Select Report">
                <el-option
                  v-for="item in packageSettings.reportOptions"
                  :key="item.id"
                  :label="item.pub"
                  :value="item.name"
                ></el-option>
              </el-select>
              <p>The default report is the version of the report which is emailed.</p>
            </el-form-item>
            <el-form-item v-if="packageSettings.emails.length > 0" label="Only use these Emails:">
              <div style="height: 10px;"></div>
              <el-checkbox style="white-space: normal;"
                v-model="packageSettings.ignoreAdminEmails"
              >Ignore administrator emails and only use the following emails below.</el-checkbox>
            </el-form-item>
            <el-form-item label="Package Emails:">
              <div style="margin-top:3px;">
                <span v-for="email in packageSettings.emails" :key="email.$index">
                  <el-button
                    size="mini"
                    round
                    style="margin-right: 5px;"
                    @click="showEmailDelete(email)"
                  >{{email}}</el-button>
                </span>
                <div v-if="packageSettings.emails.length === 0" style="padding-bottom:1em;">
                  <el-alert title="No emails have been assigned to this package." type="info"></el-alert>
                </div>
                <el-button
                  size="mini primary"
                  icon="el-icon-edit"
                  round
                  style="margin-right: 5px;"
                  @click="showEmailAdd()"
                >Add Email</el-button>
              </div>
            </el-form-item>

            <!-- <el-form-item label="Package Logo:" prop="emailSubject">
              <el-input v-model="packageSettings.logo"></el-input>
            </el-form-item>-->

            <el-form-item>
              <el-button @click="saveSettings()">Save</el-button>
              <el-button type="primary" @click="saveSettings(true)">Save &amp; Close</el-button>
              <!-- <el-button @click="cancel()">Cancel</el-button> -->
            </el-form-item>
          </el-form>
        </b-card>
      </b-col>
      <b-col sm="5">
        <b-card
          v-if="getEnabledPackages || isDistributor || isEmulated"
          :header="'Package Expansion'"
        >
          <el-form ref="packageExpansion" label-width="160px" class="demo-settings-form">
            <p>To expand your package by "x" number, use the form below.</p>
            <el-form-item label="Number:" prop="name">
              <el-input
                type="number"
                v-model="packageExpansion.number"
                style="width:40%;"
                clearable
                :min="1"
                :max="100000"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <!-- <el-button @click="saveSettings()">Save</el-button> -->
              <el-button type="primary" @click="adjustPackageSize()">Save &amp; close</el-button>
              <!-- <el-button @click="cancel()">Cancel</el-button> -->
            </el-form-item>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { unserialize } from '../../shared/unserialize.js';
import axios from '../../shared/axios';

export default {
  computed: {
    ...mapGetters('packages', [
      'getPackageList',
      'getPackageUsers',
      'getUserIdsForCurrent',
      'getPackageUsersPage',
      'getPackageUsersPageSize',
      'getPackageNameById',
      'getPackageSettings'
    ]),
    ...mapGetters('settings', ['getEnabledPackages', 'getEnabledImportWizard']),
    ...mapGetters('auth', [
      'getCompanyName',
      'getDistributorName',
      'isDistributor',
      'isEmulated',
      'getUsername',
      'getToken',
      'is360Enabled'
    ])
  },
  data() {
    return {
      packageId: undefined,
      rules: {},
      removeEmail: '',
      emailAddForm: false,
      emailDeleteForm: false,
      newEmailForm: {
        email: ''
      },
      newEmailRules: {
        email: [
          {
            required: true,
            type: 'email',
            message: 'Please input an email address',
            trigger: 'blur'
          }
        ]
      },
      packageSettings: {
        ignoreAdminEmails: false,
        name: '',
        defaultReport: '',
        emails: [],
        logo: '',
        reportOptions: []
      },
      packageExpansion: {
        number: 0
      }
    };
  },
  created() {
    if (this.$route.params.packageId) {
      this.packageId = parseInt(this.$route.params.packageId, 0);
    }
    this.fetchClientSettings();
    this.fetchPackageList();
    this.fetchPackageSettings(this.packageId).then(() => {
      const s = this.getPackageSettings;
      console.log(s.data.package);
      this.packageSettings.name = s.data.package.block_name;

      const dr = unserialize(s.data.package.default_report);
      let reportName = '';
      for (const testId in dr) {
        reportName = dr[testId];
      }
      this.packageSettings.defaultReport = reportName;
      this.packageSettings.ignoreAdminEmails =
        parseInt(s.data.package.package_email_only, 10) === 1 ? true : false;

      if (s.data.package.emails.trim().length > 0) {
        if (s.data.package.emails.indexOf(',') > -1) {
          this.packageSettings.emails = s.data.package.emails.split(',');
        } else {
          this.packageSettings.emails.push(s.data.package.emails);
        }
      }

      const reports = [];
      for (const inc in s.data.reports) {
        reports.push(unserialize(s.data.reports[inc].languages_supported));
      }

      for (const inc in s.data.association) {
        let abbr = undefined;
        let pub = undefined;
        for (const inc2 in s.data.reportNames) {
          if (
            s.data.reportNames[inc2].verbose_name ===
            s.data.association[inc].report_name
          ) {
            abbr = s.data.reportNames[inc2].abbreviated_name;
            pub = s.data.reportNames[inc2].public_name;
          }
        }
        this.packageSettings.reportOptions.push({
          id: s.data.association[inc].id,
          name: s.data.association[inc].report_name,
          lang: s.data.association[inc].language,
          abbr: abbr,
          pub: pub
        });
      }
    });
  },
  methods: {
    ...mapActions('settings', ['fetchClientSettings']),
    ...mapActions('packages', ['fetchPackageList', 'fetchPackageSettings']),
    ...mapActions('tests', ['fetchTests']),
    showEmailDelete(email) {
      this.emailDeleteForm = true;
      this.removeEmail = email;
    },
    confirmAddEmail() {
      const e = this.newEmailForm.email;
      this.packageSettings.emails.push(e);
      this.emailAddForm = false;
    },
    confirmDeleteEmail(email) {
      const i = this.packageSettings.emails.indexOf(this.removeEmail);
      if (i > -1) {
        this.packageSettings.emails.splice(i, 1);
      }
      this.emailDeleteForm = false;
    },
    showEmailAdd() {
      this.emailAddForm = true;
      this.newEmailForm.email = '';
    },
    cancel() {
      window.history.back();
    },
    saveSettings(close = false) {
      axios
        .post('/packages/settings/' + this.packageId, {
          name: this.packageSettings.name,
          emails: this.packageSettings.emails.join(','),
          ignore: this.packageSettings.ignoreAdminEmails,
          defaultReport: this.packageSettings.defaultReport
        })
        .then(r => {
          // console.log(r);
          this.$message({
            message: 'Saved settings',
            type: 'success'
          });
          if (close) {
            setTimeout(() => {
              this.$router.push('/packages');
            }, 500);
          }
        })
        .catch(e => {
          console.log(e);
          this.$message.error("Can't save settings");
        });
    },
    adjustPackageSize() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      axios
        .post('/packages/expand/' + this.packageId, {
          increaseBy: this.packageExpansion.number
        })
        .then(() => {
          this.$message({
            message: 'Increased Package',
            type: 'success'
          });
          setTimeout(() => {
            loading.close();
            this.$router.push('/packages');
          }, 500);
        })
        .catch(e => {
          console.log(e);
          loading.close();
          this.$message.error("Can't expand package");
        });
    }
  }
};
</script>
